/**
 * Onboarding plan templates — UI mirror of functions/src/config/plans.js.
 *
 * The SERVER (functions/src/onboarding/core.js) is authoritative for what gets
 * written; this mirror exists only so the Onboard modal can show a plan picker
 * and a live preview without a round-trip. Keep the two in sync — if you add a
 * plan or change a rate in functions/src/config/plans.js, update it here too.
 */
export const ADMIN_FEE = 0.2; // 20% management fee
const withFee = (cost) => Math.round(cost * (1 + ADMIN_FEE) * 100) / 100;

const managedServices = [
  {
    key: 'workspace',
    description: 'Google Workspace Starter (managed, +20%)',
    frequency: 'monthly',
    perSeatRate: withFee(7.0), // $8.40 / seat / mo
  },
  {
    key: 'domain',
    description: 'Domain renewal (managed, +20%)',
    frequency: 'yearly',
    rate: withFee(11.48), // $13.78 / yr
  },
];

export const ONBOARDING_PLANS = {
  'managed-basic': {
    name: 'Managed Services — Workspace + Domain + Firebase',
    currency: 'USD',
    gcpMarkup: ADMIN_FEE,
    subscriptions: managedServices,
  },
  'web-managed': {
    name: 'Website + Managed Services',
    currency: 'USD',
    gcpMarkup: ADMIN_FEE,
    oneTime: { currency: 'PHP', description: 'Website design & development', defaultAmount: 64000 },
    subscriptions: managedServices,
  },
};

export const PLAN_OPTIONS = Object.entries(ONBOARDING_PLANS).map(([id, p]) => ({
  id,
  name: p.name,
}));
